import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ContactButton from "../components/ContactButton";
import { BOOK_CALL_URLS } from "../constants";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
} from "../hooks/useScrollAnimation";

import "./SingleOrderBanner.css";

export default function SingleOrderBanner() {
  const { t, i18n } = useTranslation();
  const fadeInUp = getScrollAnimationVariants("fadeInUp");
  const lang = i18n.language.startsWith("pl") ? "pl" : "en";

  return (
    <motion.section
      className="single-order-banner"
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={fadeInUp}
    >
      <div className="single-order-inner">
        <div className="single-order-badge">
          {t("singleOrder.badge")}
        </div>
        <h3 className="single-order-headline">
          {t("singleOrder.hook")}
          <br />
          {t("singleOrder.subhook")}
        </h3>
        <p className="single-order-desc">{t("singleOrder.description")}</p>
        <div className="single-order-features">
          <div className="single-order-feature">
            <span className="single-order-check">&#10003;</span>
            {t("singleOrder.feature1")}
          </div>
          <div className="single-order-feature">
            <span className="single-order-check">&#10003;</span>
            {t("singleOrder.feature2")}
          </div>
          <div className="single-order-feature">
            <span className="single-order-check">&#10003;</span>
            {t("singleOrder.feature3")}
          </div>
        </div>
        <ContactButton
          href={BOOK_CALL_URLS[lang]}
          variant="primary"
          size="large"
        >
          {t("singleOrder.cta")}
        </ContactButton>
      </div>
    </motion.section>
  );
}
